__turbopack_context__.v({
  "description": "GithubRepoTile-module-scss-module__Vd45tq__description",
  "footerMetrics": "GithubRepoTile-module-scss-module__Vd45tq__footerMetrics",
  "gitRepoTile": "GithubRepoTile-module-scss-module__Vd45tq__gitRepoTile",
  "header": "GithubRepoTile-module-scss-module__Vd45tq__header",
  "lang-yara": "GithubRepoTile-module-scss-module__Vd45tq__lang-yara",
  "languageDot": "GithubRepoTile-module-scss-module__Vd45tq__languageDot",
  "metric": "GithubRepoTile-module-scss-module__Vd45tq__metric",
  "publicTag": "GithubRepoTile-module-scss-module__Vd45tq__publicTag",
  "repoName": "GithubRepoTile-module-scss-module__Vd45tq__repoName",
});
